import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';
import { Fragment } from 'react';
import { appAssetsCdnUrl } from '~/constants/environment';
import optimizeImage from '~/utilities/optimizeImage';
import styles from './AffordableCarsGraphic.module.css';

const zeroToNine = Array.from({ length: 10 }, (_, i) => i);

const Number = createComponent('div', { className: 'w-[35px] text-center' });

type NumbersProps = {
  start: number;
  stop: number;
};

function Numbers(props: NumbersProps) {
  return (
    <Number
      className={styles.slotMachine}
      style={
        {
          '--start-number': props.start,
          '--stop-number': props.stop
        } as React.CSSProperties
      }
    >
      {zeroToNine.map(num => (
        <Fragment key={num}>
          <div>{num}</div>
          <div className="invisible">{num}</div>
        </Fragment>
      ))}
    </Number>
  );
}

type OwnProps = {
  overlayColor?: string;
  overlayPosition?: 'bottom' | 'both';
  showOverlay?: boolean;
};

export default function AffordableCarsGraphic({
  overlayColor,
  overlayPosition = 'both',
  showOverlay = true
}: OwnProps) {
  return (
    <div className="flex-1">
      <div
        className={cx(
          'relative h-[100px] overflow-hidden text-text-strong-active',
          styles.fadeIn
        )}
      >
        <div className="absolute top-[15px] flex t-brand-xl">
          <Number>$</Number>
          <Numbers start={6} stop={1} />
          <Numbers start={2} stop={8} />
          <div className="-mr-4 ml-4">,</div>
          <Numbers start={0} stop={5} />
          <Numbers start={0} stop={9} />
          <Numbers start={9} stop={0} />
        </div>
        {showOverlay && (
          <div
            className={cx(
              'absolute inset-0',
              overlayPosition === 'bottom'
                ? styles.overlayBottom
                : styles.overlay
            )}
            style={
              overlayColor
                ? ({ '--overlay-color': overlayColor } as React.CSSProperties)
                : undefined
            }
          />
        )}
      </div>
      <img
        src={optimizeImage(
          `${appAssetsCdnUrl}/images/home/budget-affordable-cars.png`,
          { format: 'auto' }
        )}
        alt=""
        className="relative -mt-[43px]"
        loading="lazy"
      />
    </div>
  );
}
